import { Injectable } from '@angular/core';
import { HttpService } from '../../core/services/http.service';

@Injectable({ providedIn: 'root' })
export class ConnectionsService {

  private listUrl = 'partners/services/list';
  private listGroupUrl = 'partners/services/list-group';
  private servicesByIdUrl = 'partners/services/services-by-id';

  private typesUrl = 'partners/services/types';
  private filterUrl = 'partners/services/filter';
  private filter3dsUrl = 'partners/services/filter-3ds';
  private rankingUrl = 'partners/services/ranking';
  private allUrl = 'partners/services/all';
  private getUrl = 'partners/services/get';
  private getByIdUrl = 'partners/services/getById';
  private getByNameUrl = 'partners/services/getByName';
  private versionsUrl = 'partners/services/versions';
  private registerUrl = 'partners/services/save';
  private registerTunaUrl = 'partners/services/save-tuna';
  private taxesUrl = 'partners/services/taxes';
  private brandTaxesUrl = 'partners/services/brandTaxes';
  private antifraudTaxesUrl = 'partners/services/antifraudTaxes';
  private methodTypeTaxesUrl = 'partners/services/methodTypeTaxes';
  private saveBrandTaxesUrl = 'partners/services/saveBrandTaxes';
  private saveAntifraudTaxesUrl = 'partners/services/saveAntifraudTaxes';
  private saveMethodTypeTaxesUrl = 'partners/services/saveMethodTypeTaxes';
  private duplicateUrl = 'partners/services/duplicate';
  private disableUrl = 'partners/services/disable';
  private enableUrl = 'partners/services/enable';
  private saveWizardUrl = 'partners/services/save-wizard-service';
  private loadServicesWizardUrl = 'partners/services/load-wizard-service';
  private listFilterOptionsUrl = 'transactions/filter';
  private downloadConnectionsUrl = 'partners/services/download-connections';

  constructor(private httpService: HttpService) { }

  list(partner: string, account: string, params) {
    return this.httpService.post(this.listUrl, params, partner, account, false);
  }

  listGroup(partner: string, account: string, params) {
    return this.httpService.post(this.listGroupUrl, params, partner, account, true);
  }

  listById(partner: string, account: string, service_id, status) {

    var params = {
      partner_key: null,
      account_key: null,
      payment_method_type_ids: null,
      card_brand_ids: null,
      service_id: service_id,
      status
    };

    return this.httpService.post(this.servicesByIdUrl, params, partner, account, true);
  }

  getTypes(partner: string, account: string) {
    return this.httpService.get(this.typesUrl, partner, account, false);
  }

  listFilterOptions(partner: string, account: string) {
    return this.httpService.get(this.listFilterOptionsUrl, partner, account, false);
  }

  getRanking(partner: string, account: string, params) {
    return this.httpService.post(this.rankingUrl, params, partner, account, false);
  }

  filter(partner: string, account: string, serviceTypeId, loading) {

    const params = {
      service_types_id: serviceTypeId
    };

    return this.httpService.post(this.filterUrl, params, partner, account, loading);
  }

  all(partner: string, account: string) {
    return this.httpService.get(this.allUrl, partner, account, true);
  }

  get(partner: string, account: string, service_id: string, version_id: string, partner_key, account_key) {
    const params = {
      service_id,
      version_id,
      partner_key,
      account_key
    };

    return this.httpService.post(this.getUrl, params, partner, account, true);
  }

  getById(partner: string, account: string, service_id: string) {
    const params = {
      service_id
    };

    return this.httpService.post(this.getByIdUrl, params, partner, account);
  }

  getByName(partner: string, account: string, service_name: string, partner_key, account_key) {
    const params = {
      service_name,
      partner_key,
      account_key
    };

    return this.httpService.post(this.getByNameUrl, params, partner, account, true);
  }

  version(partner: string, account: string, service_id: string, version_id: string) {
    const params = {
      service_id,
      version_id
    };

    return this.httpService.post(this.versionsUrl, params, partner, account);
  }


  register(partner: string, account: string, service_id: string, version_id: string, name: string, configurations: string, file, active, is_service_tuna, partner_key?: string, account_key?: string) {

    let params = {
      service_id,
      version_id,
      name,
      configurations,
      active: active,
      is_service_tuna,
      file,
      partner_key,
      account_key
    };

    return this.httpService.post(this.registerUrl, params, partner, account, true);
  }


  saveTuna(partner: string, account: string, params) {

    return this.httpService.post(this.registerTunaUrl, params, partner, account, true);
  }

  getTaxesBoletoBrands(partner: string, account: string, params) {

    return this.httpService.post(this.taxesUrl, params, partner, account, true);
  }

  brandTaxes(partner: string, account: string, params) {

    return this.httpService.post(this.brandTaxesUrl, params, partner, account, true);
  }

  antifraudTaxes(partner: string, account: string, params) {

    return this.httpService.post(this.antifraudTaxesUrl, params, partner, account, true);
  }

  methodTypeTaxes(partner: string, account: string, params) {

    return this.httpService.post(this.methodTypeTaxesUrl, params, partner, account, true);
  }

  saveBrandTaxes(partner: string, account: string, params) {

    return this.httpService.post(this.saveBrandTaxesUrl, params, partner, account, true);
  }

  saveAntifraudTaxes(partner: string, account: string, params) {

    return this.httpService.post(this.saveAntifraudTaxesUrl, params, partner, account, true);
  }

  saveMethodTypeTaxes(partner: string, account: string, params) {

    return this.httpService.post(this.saveMethodTypeTaxesUrl, params, partner, account, true);
  }

  duplicate(partner: string, account: string, service_id: string, version_id: string, name: string) {
    const params = {
      service_id,
      version_id,
      name
    };

    return this.httpService.post(this.duplicateUrl, params, partner, account);
  }

  disable(partner: string, account: string, service_id: string, version_id: string) {
    const params = {
      service_id,
      version_id,
      account_key: null,
      partner_key: null
    };

    return this.httpService.post(this.disableUrl, params, partner, account);
  }

  enable(partner: string, account: string, service_id: string, version_id: string) {
    const params = {
      service_id,
      version_id
    };

    return this.httpService.post(this.enableUrl, params, partner, account);
  }

  saveWizard(partner: string, account: string, payment_method_type) {
    const params = {
      payment_method_type
    };

    return this.httpService.post(this.saveWizardUrl, params, partner, account);
  }

  loadWizardService(partner, account) {
    return this.httpService.get(this.loadServicesWizardUrl, partner, account);
  }


  downloadConnections(partner: string, account: string, params) {
    return this.httpService.post(this.downloadConnectionsUrl, params, partner, account);
  }
}
